<div class="conatiner-div d-flex flex-column">
  <div class="topHead d-flex justify-content-between">
    <span>Search data</span>
    <div class="close-button" mat-button mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>
  <div class="filter-div">
    @if(data.state && data.district){
    <div class="d-flex flex-column input-div">
      <span class="input-text">User Name</span>
      <input class="search-input dp-input-control" type="tel" placeholder="Enter user name" aria-label="searchUser"
        [formControl]="userName" />
    </div>
    <div class="d-flex flex-column input-div">
      <span class="input-text">User email</span>
      <input class="search-input dp-input-control" type="tel" placeholder="Enter user email" aria-label="Email"
        [formControl]="email" />
    </div>
    }
    <div class="d-flex flex-column input-div">
      <span class="input-text">Select Roles</span>
      <mat-form-field class="select-mat-form-field custom-select-form">
        <mat-select [formControl]="roleType" placeholder="Select Status" class="custom-mat-select custom-select"
          (selectionChange)="getRoleList(roleType)" multiple>
          <mat-option *ngFor="let option of roleTypes" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>

      </mat-form-field>
    </div>

    <div class="d-flex btn-main-div">
      <button class="dp-secondary-btn btn-div" (click)="onClearClick()">
        Clear all
      </button>

      <button class="dp-primary-btn btn-div" (click)="onSearchClick()">
        Search
      </button>
    </div>
  </div>
</div>